import { Container, Size, ShowFor } from "@brightagency/headstart-common";
import React, { ReactNode } from "react";
import { CarouselControls } from "../../molecules/CarouselControls";
import { Wrapper, Inner, Title, Content, TextContent, Header } from "./styled";

interface Props {
    id?: string;
    title: string;
    description?: string;
    carousel?: {
        content: ReactNode;
        onScrollLeft: () => void;
        onScrollRight: () => void;
        canScroll: boolean;
        displayControl: boolean;
    };
    children?: ReactNode;
}

export const CarouselSection: React.FC<Props> = props => {
    return (
        <Wrapper id={props.id} className="carousel-wrapper">
            {props.title && (
            <Container>
                <Inner>
                    <Header>
                        <TextContent>
                            <Title>{props.title}</Title>
                            {props.description && <Content>{props.description}</Content>}
                        </TextContent>
                        {props.carousel?.displayControl && props.carousel?.content && props.carousel.canScroll && (
                            <ShowFor size={Size.large}>
                                <CarouselControls
                                    onLeftClick={props.carousel.onScrollLeft}
                                    onRightClick={props.carousel.onScrollRight}
                                />
                            </ShowFor>
                        )}
                    </Header>
                    {/* Children only gets rendered as a fallback to the carousel not having content */}
                    {!props.carousel?.content && props.children}
                </Inner>
            </Container>
            )}
            {props.carousel?.content}
        </Wrapper>
    );
};
